import React from "react";
import { Typography } from "@mui/material";
import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()(() => ({
	row: {
		fontSize: "13px",
		color: "#374151",
	},
	label: {
		fontWeight: 600,
		marginRight: "4px",
	},
}));

const SubscriptionFiltersDisplay = ({ filters = [] }) => {
	const { classes } = useStyles();
	if (!filters.length) return null;
	const inline = filters
		.map(({ label, value }) => `${label} = ${value}`)
		.join(", ");
	return (
		<Typography className={classes.row}>
			<span className={classes.label}>Filters:</span>
			{inline}
		</Typography>
	);
};

export default SubscriptionFiltersDisplay;
